import { ResourceType, Propagation, GLGlobal, Permission } from "../utils";
import { ServiceRoute, GLServiceBase } from "./service";
import { isUndefined } from "lodash";
import { AccessLevel } from "@/util/enum";
import { GLBase } from "../request";
import { ResponseHelper } from "@/util/helper";
import { ContentAdmin } from "@/models/user-model";

export type ResourcePropagation = {
	resourceType: ResourceType;
	resourceKey: string;
};

export interface AllowedPermissionRequestModal {
	permissionId: number;
	accessLevel: AccessLevel;
}
class PermissionServiceClass extends GLServiceBase<any, any> {
	serviceRoute: ServiceRoute = { prefix: "content/v1/vcs" };

	getPermissions(userId?: string) {
		let permissionPromise: Promise<GLBase> | null = null;

		if (isUndefined(userId)) {
			permissionPromise = this.request.get(this.url("permissions"));
		} else {
			permissionPromise = this.get("permissions", { userId: userId });
		}

		return permissionPromise.catch((reason) => {
			if (ResponseHelper.isForbiddenResponse(reason)) {
				return [
					{ id: -1, name: "No Permission", accessLevel: AccessLevel.None, items: [] as Permission[] }
				] as Permission[];
			}
		});
	}

	saveUserPermissions(userId: string | null, allowedPermissions: AllowedPermissionRequestModal[], contentAdmin: ContentAdmin | undefined) {
		const data = {
			permissions: allowedPermissions,
			userContext: null as unknown
		};

		if (contentAdmin) {
			const { id, email, phone, name } = contentAdmin;
			data.userContext = { id, email, phone, name };
		}

		return this.create("{userId}/savepermission", data, { userId: userId });
	}

	removepermission(userId: string) {
		return this.create("{userId}/removepermission", null, { userId: userId });
	}
}

export const PermissionService = new PermissionServiceClass();
